var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { BigNumber } from "ethers";
import { EVMVaultList, getVaultNetwork, isEarnVault, isPutVault, TreasuryVaultList, VIPVaultList, } from "../constants/constants";
import { isProduction, isTreasury, isVIP } from "../utils/env";
import { getVaultContract } from "./useVaultContract";
import { getStrikeSelectionContract } from "./useStrikeSelection";
import { impersonateAddress } from "../utils/development";
import { defaultV2VaultData, } from "../models/vault";
import { usePendingTransactions } from "./pendingTransactionsContext";
import { useEVMWeb3Context } from "./useEVMWeb3Context";
import { isVaultSupportedOnChain } from "../utils/vault";
import { calculatePricePerShare, getNextFridayTimestamp } from "../utils/math";
var useFetchV2VaultData = function () {
    var _a = useWeb3React(), chainId = _a.chainId, web3Active = _a.active, web3Account = _a.account, library = _a.library;
    var account = impersonateAddress ? impersonateAddress : web3Account;
    var expiryTimestamp = getNextFridayTimestamp();
    var transactionsCounter = usePendingTransactions().transactionsCounter;
    var getProviderForNetwork = useEVMWeb3Context().getProviderForNetwork;
    var _b = useState(defaultV2VaultData), data = _b[0], setData = _b[1];
    var _c = useState(0), setMulticallCounter = _c[1];
    var doMulticall = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentCounter, vaultList, responses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isProduction()) {
                        console.time("V2 Vault Data Fetch"); // eslint-disable-line
                    }
                    setMulticallCounter(function (counter) {
                        currentCounter = counter + 1;
                        return currentCounter;
                    });
                    vaultList = isTreasury()
                        ? TreasuryVaultList
                        : isVIP()
                            ? VIPVaultList
                            : EVMVaultList;
                    return [4 /*yield*/, Promise.all(vaultList.map(function (vault) { return __awaiter(void 0, void 0, void 0, function () {
                            var inferredProviderFromVault, active, contract, strikeSelectionAddress, _a, strikeSelectionContract, unconnectedPromises, promises, _b, totalBalance, cap, _vaultState, lastQueuedWithdrawAmount, totalSupply, decimals, _getStrikePrice, _depositReceipts, shares, _withdrawals, _c, _d, totalPending, _e, queuedWithdrawShares, _f, round, actualPricePerShare, accountVaultBalance, getStrikePrice, depositReceipts, withdrawals;
                            var _g;
                            return __generator(this, function (_h) {
                                switch (_h.label) {
                                    case 0:
                                        inferredProviderFromVault = getProviderForNetwork(getVaultNetwork(vault));
                                        active = Boolean(web3Active &&
                                            isVaultSupportedOnChain(vault, chainId || ((_g = inferredProviderFromVault === null || inferredProviderFromVault === void 0 ? void 0 : inferredProviderFromVault._network) === null || _g === void 0 ? void 0 : _g.chainId)));
                                        contract = getVaultContract(library || inferredProviderFromVault, vault, active);
                                        if (!contract) {
                                            return [2 /*return*/, { vault: vault }];
                                        }
                                        if (!!isEarnVault(vault)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, contract.strikeSelection().catch(function (e) {
                                                return undefined;
                                            })];
                                    case 1:
                                        _a = _h.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = undefined;
                                        _h.label = 3;
                                    case 3:
                                        strikeSelectionAddress = _a;
                                        strikeSelectionContract = strikeSelectionAddress
                                            ? getStrikeSelectionContract(library || inferredProviderFromVault, strikeSelectionAddress, active)
                                            : undefined;
                                        unconnectedPromises = [
                                            contract.totalBalance(),
                                            contract.cap(),
                                            contract.vaultState(),
                                            contract.lastQueuedWithdrawAmount(),
                                            contract.totalSupply(),
                                            contract.decimals(),
                                            strikeSelectionContract
                                                ? strikeSelectionContract.getStrikePrice(expiryTimestamp, isPutVault(vault))
                                                : Promise.resolve({
                                                    newStrikePrice: BigNumber.from(0),
                                                    newDelta: BigNumber.from(0),
                                                }),
                                        ];
                                        promises = unconnectedPromises.concat(active
                                            ? [
                                                contract.depositReceipts(account),
                                                contract.shares(account),
                                                contract.withdrawals(account),
                                            ]
                                            : [
                                                // Default value when not connected
                                                Promise.resolve({ amount: BigNumber.from(0), round: 1 }),
                                                Promise.resolve(BigNumber.from(0)),
                                                Promise.resolve({ round: 1, shares: BigNumber.from(0) }),
                                            ]);
                                        return [4 /*yield*/, Promise.all(
                                            // Default to 0 when error
                                            promises.map(function (p) {
                                                return p.catch(function (e) {
                                                    return BigNumber.from(0);
                                                });
                                            }))];
                                    case 4:
                                        _b = _h.sent(), totalBalance = _b[0], cap = _b[1], _vaultState = _b[2], lastQueuedWithdrawAmount = _b[3], totalSupply = _b[4], decimals = _b[5], _getStrikePrice = _b[6], _depositReceipts = _b[7], shares = _b[8], _withdrawals = _b[9];
                                        _c = (_vaultState || {}), _d = _c.totalPending, totalPending = _d === void 0 ? BigNumber.from(1) : _d, _e = _c.queuedWithdrawShares, queuedWithdrawShares = _e === void 0 ? BigNumber.from(1) : _e, _f = _c.round, round = _f === void 0 ? 1 : _f;
                                        actualPricePerShare = calculatePricePerShare(decimals, totalBalance, totalPending, lastQueuedWithdrawAmount, totalSupply, queuedWithdrawShares);
                                        accountVaultBalance = shares
                                            .mul(actualPricePerShare)
                                            .div(BigNumber.from("10").pow(decimals));
                                        getStrikePrice = (_getStrikePrice.newStrikePrice
                                            ? _getStrikePrice
                                            : { newStrikePrice: BigNumber.from(0) });
                                        depositReceipts = (_depositReceipts.amount
                                            ? _depositReceipts
                                            : { amount: BigNumber.from(0), round: 1 });
                                        withdrawals = (_withdrawals.round
                                            ? _withdrawals
                                            : { shares: BigNumber.from(0), round: 1 });
                                        return [2 /*return*/, {
                                                vault: vault,
                                                totalBalance: totalBalance,
                                                cap: cap,
                                                pricePerShare: actualPricePerShare,
                                                round: round,
                                                strikePrice: getStrikePrice.newStrikePrice,
                                                lockedBalanceInAsset: accountVaultBalance,
                                                depositBalanceInAsset: depositReceipts.round === round
                                                    ? depositReceipts.amount
                                                    : BigNumber.from(0),
                                                withdrawals: withdrawals,
                                            }];
                                }
                            });
                        }); }))];
                case 1:
                    responses = _a.sent();
                    setMulticallCounter(function (counter) {
                        if (counter === currentCounter) {
                            setData(function (prev) { return ({
                                responses: Object.fromEntries(responses.map(function (_a) {
                                    var vault = _a.vault, withdrawals = _a.withdrawals, response = __rest(_a, ["vault", "withdrawals"]);
                                    return [
                                        vault,
                                        __assign(__assign(__assign({}, prev.responses[vault]), response), { withdrawals: withdrawals || prev.responses[vault].withdrawals }),
                                    ];
                                })),
                                loading: false,
                            }); });
                        }
                        return counter;
                    });
                    if (!isProduction()) {
                        console.timeEnd("V2 Vault Data Fetch"); // eslint-disable-line
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [
        getProviderForNetwork,
        web3Active,
        chainId,
        library,
        expiryTimestamp,
        account,
    ]);
    useEffect(function () {
        doMulticall();
    }, [doMulticall, transactionsCounter]);
    return data;
};
export default useFetchV2VaultData;
//# sourceMappingURL=useFetchV2VaultData.js.map